import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">OBX Post · Your Source for Local News</p>
        <h1>Stay Informed with OBX Post</h1>
        <p className="lede">
          Discover the latest updates, events, and community stories from the Outer Banks. 
          We bring you closer to the heart of our vibrant region.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/events" target="_self" className="secondary">
            Explore Upcoming Events
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Updates</h2>
          <p>
            Stay updated with real-time news and stories that matter to the Outer Banks community.
          </p>
        </article>
        <article>
          <h2>Community Events</h2>
          <p>
            Find out about local events and activities happening in your area. Join us in celebrating our community.
          </p>
        </article>
        <article>
          <h2>In-Depth Stories</h2>
          <p>
            Dive into feature stories that highlight the unique culture and people of the Outer Banks.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;